import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { ProductSize, GraphQLProductSize } from '../types'

export type CreateProductSizeAction = FSA<undefined, ProductSize, string>
type CreateProductSize = (productSizeData: ProductSizeInput) => MrxThunk<CreateProductSizeAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'createProductSize', GraphQLProductSize>

const CREATE_PRODUCT_SIZE = `
  mutation createProductSize ($workspaceId: Int!, $productSizeData: ProductSizeDataInput!) {
    createProductSize(workspaceId: $workspaceId, productSizeData: $productSizeData) {
      id
      workspaceId
      name
      displayName
      createdAt
      updatedAt
    }
  }
`
type ProductSizeInput = {
  name: string
  displayName: string
}

const createProductSize: CreateProductSize = (productSizeData) => async (dispatch, getState) => {
  let isSaved = false

  dispatch({
    type: t.CREATE_PRODUCT_SIZE,
    meta: { done: false }
  })

  try {
    const workspaceId = getState()?.workspaces?.activeWorkspace?.id
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: CREATE_PRODUCT_SIZE,
      variables: { workspaceId, productSizeData }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { createProductSize } = data
    if (!createProductSize) {
      throw new Error("Can't create product size!")
    }

    dispatch({
      type: t.CREATE_PRODUCT_SIZE,
      payload: createProductSize,
      meta: { done: true }
    })
    isSaved = true
  } catch (err) {
    dispatch({
      type: t.CREATE_PRODUCT_SIZE,
      payload: extractErrorInfo(err) as string,
      error: true
    })
  }

  return isSaved
}

export { createProductSize }
